/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgencyEmailSearchCriteriaDto { 
    addressPhysicalCity?: string;
    addressPhysicalStateLookup?: string;
    addressPhysicalStreet?: string;
    addressPhysicalZip?: string;
    agencyName?: string;
    agencyStatusTypeId?: AgencyEmailSearchCriteriaDto.AgencyStatusTypeIdEnum;
    agencyType?: AgencyEmailSearchCriteriaDto.AgencyTypeEnum;
    createdWithinDays?: number;
    expiresWithinDays?: number;
    serviceTypeLookup?: string;
    testAgency?: boolean;
    treatmentLookup?: string;
}
export namespace AgencyEmailSearchCriteriaDto {
    export const AgencyStatusTypeIdEnum = {
        Approved: 'Approved',
        BeingReviewed: 'Being Reviewed',
        Denied: 'Denied',
        Inactive: 'Inactive',
        NotSubmitted: 'Not Submitted',
        RenewalAlert: 'Renewal Alert',
        RenewalExpired: 'Renewal Expired',
        RenewalWarning: 'Renewal Warning',
        ResubmissionRequired: 'Resubmission Required',
        ResubmissionRequiredImmediately: 'Resubmission Required Immediately'
    } as const;
    export type AgencyStatusTypeIdEnum = typeof AgencyStatusTypeIdEnum[keyof typeof AgencyStatusTypeIdEnum];
    export const AgencyTypeEnum = {
        Private: 'PRIVATE',
        Public: 'PUBLIC'
    } as const;
    export type AgencyTypeEnum = typeof AgencyTypeEnum[keyof typeof AgencyTypeEnum];
}


